export default __webpack_public_path__ + "static/media/payment.df179db3.svg";